import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import './DeleteLessonButton.css';

function DeleteTestButton({ testId, testTitle, onDeleteSuccess }) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm(`هل أنت متأكد من حذف الاختبار "${testTitle}"؟`)) {
      return;
    }

    setIsDeleting(true);
    
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }

      const response = await fetch(`https://newalemny.3almny.app/api/tests/delete_test/${testId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('تم حذف الاختبار بنجاح');
        if (onDeleteSuccess) {
          onDeleteSuccess();
        }
      } else {
        toast.error(data.message || 'فشل في حذف الاختبار');
      }
    } catch (error) {
      console.error('Error deleting test:', error);
      toast.error('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <button
      className="delete-lesson-btn"
      onClick={handleDelete}
      disabled={isDeleting}
      title="حذف الاختبار"
    >
      <FaTrash />
      {isDeleting ? 'جاري الحذف...' : 'حذف'}
    </button>
  );
}

export default DeleteTestButton;
